import React from "react";
import PropTypes from "prop-types";
import { Notebook } from "@learningblocks/storybook-components";
import { GlossaryButton } from "@learningblocks/storybook-components";
import { MenuContentList } from "./MenuContentList";
import { Utilities } from "@learningblocks/exp-constants";
const { resetScroll } = Utilities;

import "./style.scss";

/**
 * NotebookExpDesignTab:
 * - Used to display the Nootbook of experimental design [TAB view]
 */
export function NotebookExpDesignTab(props) {
  React.useEffect(() => {
    resetScroll("tab-book");
  }, [props.currentMenu]);

  return (
    <Notebook.Wrapper className="tab-book">
      <Notebook.Header className="tab-book_header">
        <Notebook.TitleBlock
          className="index-titleBlock"
          title={props.title}
          text={props.description}
          ariaLabel="Lab notebook section heading."
        />
        <GlossaryButton className="index-glossaryIcon" />
      </Notebook.Header>
      <MenuContentList
        onSelect={props.onSetChapter}
        menuList={props.menuList}
        components={props.components}
        currentMenu={props.currentMenu}
        nextMenuValue={props.nextMenuValue}
      />
    </Notebook.Wrapper>
  );
}

NotebookExpDesignTab.propTypes = {
  /**
   * Components in current section to be displayed in Notebook
   */
  components: PropTypes.arrayOf(PropTypes.object),
  /**
   * Details of currently active menu in menu list
   */
  currentMenu: PropTypes.shape({
    /**
     * Index of menu
     */
    number: PropTypes.number,
    /**
     * Title of menu
     */
    title: PropTypes.string,
    /**
     * Value of menu
     */
    value: PropTypes.string,
  }),
  /**
   * Description to be displayed in Notebook Header
   */
  description: PropTypes.string,
  /**
   * Function to set new Chapter
   */
  onSetChapter: PropTypes.func,
  /**
   * List of Menu Items
   */
  menuList: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Title to display in  menu
       */
      title: PropTypes.string.isRequired,
      /**
       * Boolean specifying if menu is selected
       */
      current: PropTypes.bool.isRequired,
      /**
       * Index number of menu
       */
      number: PropTypes.number.isRequired,
      /**
       * Unique string value of the menu
       */
      value: PropTypes.string.isRequired,
      /**
       * Boolean set when section is visited
       */
      visited: PropTypes.bool.isRequired,
    })
  ),
  /**
   * Value for next-in-line menu
   * NONE value mens no more next section
   */
  nextMenuValue: PropTypes.oneOf([
    "CONTEXT",
    "TECHNIQUES",
    "DESIGN",
    "PROBLEM_SOLVING",
    "RESULTS",
    "REFLECTION",
    "TROUBLESHOOTING",
  ]),
  /**
   * Title of the Content to display at header
   */
  title: PropTypes.string,
};

NotebookExpDesignTab.defaultProps = {
  title: "",
  description: "",
};
